import { Routes } from '@angular/router';
import { CedantViewComponent } from './cedant-view/cedant-view.component';
import { CedantDashboardComponent } from './cedant-dashboard/cedant-dashboard.component';
import { CedantProgramViewComponent } from './cedant-program-view/cedant-program-view.component';

export const CedantRoutes: Routes = [
  { path: '', redirectTo: 'cedant',  pathMatch: 'full'},
  { path: 'cedant', component: CedantDashboardComponent ,
    children: [
      {
        path: ':cedant',
        component: CedantProgramViewComponent,
      },
      {
        path: ':cedantId/program/:programId',
        component: CedantProgramViewComponent
      }
    ]
  },
];
